import React from 'react'
import PropTypes from 'prop-types'
import * as S from './MobileHeader.styled'
import { SearchGoodsInput } from 'src/features/search-goods/ui'
import { SearchBlockMobile } from 'src/shared/ui/mobile/search-block'
import { usePopHistoryPath } from 'src/features/history-paths/hooks'
import { useStore } from 'effector-react'
import { $isOpenedSearchSection } from 'src/features/search-goods/model'

const MobileHeader = (props) => {
    const popHistoryPath = usePopHistoryPath()
    const isVisibleSuggestions = useStore($isOpenedSearchSection)
    const generateDefaultBlock = () => (
        <S.ArrowBlock onClick={popHistoryPath}>
            <S.IconArrowBack />
        </S.ArrowBlock>
    )
    const generateCustomBlock = () => {
        return (
            <S.ArrowBlock onClick={props.backClickHandler}>
                <S.IconArrowBack />
            </S.ArrowBlock>
        )
    }

    return (
        <S.Container isBorderAvailable={props.isBorderAvailable} ref={props.blockRef}>
            {props.isShowedTitle && !isVisibleSuggestions ? (
                <S.HeaderTitle>
                    {props.backClickHandler ? generateCustomBlock() : generateDefaultBlock()}
                    <S.HeaderText>{props.children}</S.HeaderText>
                    {props.right}
                </S.HeaderTitle>
            ) : (
                <React.Fragment />
            )}
            {props.searchInput?.isShowed ? <SearchGoodsInput /> : <React.Fragment />}
            {props.customSearch ? (
                <SearchBlockMobile
                    placeholder={props.customSearch.placeholder}
                    searchState={{
                        focusHandler: props.customSearch.focusHandler,
                        blurHandler: props.customSearch.blurHandler,
                        searchRef: props.customSearch.searchRef,
                        searchText: props.customSearch.searchText,
                        changeSearchText: props.customSearch.changeSearchHandler,
                        atrs: props.customSearch.atrs
                    }}
                />
            ) : (
                <React.Fragment />
            )}
        </S.Container>
    )
}

MobileHeader.propTypes = {
    blockRef: PropTypes.any,
    isDefaultRouterBack: PropTypes.bool,
    backClickHandler: PropTypes.func,
    right: PropTypes.element,
    isShowedTitle: PropTypes.bool,
    isBorderAvailable: PropTypes.bool,
    children: PropTypes.any,
    customSearch: PropTypes.shape({
        placeholder: PropTypes.string,
        searchText: PropTypes.string,
        changeSearchHandler: PropTypes.func,
        searchButtonHandler: PropTypes.func,
        keyDownHandler: PropTypes.func,
        atrs: PropTypes.any,
        // eslint-disable-next-line react/forbid-prop-types
        searchRef: PropTypes.any,
        focusHandler: PropTypes.func,
        blurHandler: PropTypes.func
    }),
    searchInput: PropTypes.shape({
        isShowed: PropTypes.bool
    })
}
MobileHeader.defaultProps = {
    isDefaultRouterBack: true,
    isBorderAvailable: true,
    searchInput: null,
    isShowedTitle: true,
    right: null,
    backClickHandler: null,
    children: ''
}

export default MobileHeader
